import PropTypes from 'prop-types'


export const SectionState = PropTypes.oneOf([
  'disabled',
  'active',
  'cleared'
])